import script from "./SearchableList.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchableList.vue?vue&type=script&setup=true&lang=js"

import "./SearchableList.vue?vue&type=style&index=0&id=42522156&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42522156"]])

export default __exports__